export default class sliderSection {
    constructor() {

        const sliderImageLongVideo = document.querySelectorAll('.slider-section__image-container.has-long-video');

        function placePlaybutton() {

            sliderImageLongVideo.forEach(video => {
                video.prepend(video.closest('.swiper-slide').querySelector('.btn-video-container'));
                video.closest('.slider-section__link-overlay').removeAttribute('href');
                const modal = video.closest('.swiper-slide').querySelector('.modal');

                if (modal) {
                    video.closest('.swiper-container').prepend(modal);
                }
            });
        }
        placePlaybutton();
    }
}
